export default __webpack_public_path__ + "static/media/connection.7e8d4189.svg";